<script lang="ts">
  import type {User} from '../types'
  import {replaceValues, t} from '../i18n'
  import LoadMore from '../shared/LoadMore.svelte'
  import ModalTemplate from '../shared/ModalTemplate.svelte'

  export let user: User
  let users: Array<User> = []
</script>

<ModalTemplate size="small" scrolling>
  <div class="modal-content">
    <h2 class="tc">{t.user.followers}</h2>
    <div class="followers-count tc">
      {replaceValues(t.user.followers_count, {n: user.followers_count})}
    </div>

    <div class="grid four tc">
      {#each users as user}
        <div class="grid__item">
          <div class="follower__photo">
            <a href={user.link}>
              <img src={user.avatar_big_thumgb} alt={user.full_name}/>
            </a>
          </div>
          <div class="follower__name">
            <a href={user.link}>{user.full_name}</a>
          </div>
        </div>
      {/each}
    </div>

    <LoadMore bind:items={users} url={`/users/${user.id}/followers`}/>
  </div>
</ModalTemplate>
